export default {
  en: {
    id: 'exercise4',
    subtitle: 'SUGGESTED STRUCTURE<br/>EXECUTIVE SUMMARY CASCADE GROUP',
    blocks: [
      {
        task: `Operating with old, obsolete IT systems, but costs too high to replace in each state.`,
        title: "S = ",
        answer: ' ',
        note: 'Sit, DE R1',
        disableEdit: true
      },
      {
        task: `Given commonalities, wonder if a single system could work for all.`,
        title: "C = ",
        answer: ' ',
        note: 'Sol, R2',
        disableEdit: true
      },
      {
        task: 'Could Eastwood develop a single system?',
        title: "Q = ",
        answer: ' ',
        disableEdit: true
      }
    ],
    image: '5c1-6.png',
    withoutAnswers: true,
    hideTaskTitle: true,
    submitButton: 'switch'
  },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise4.js